import React from "react";
import { IconButton, Tooltip } from "@mui/material";
import PictureAsPdfRoundedIcon from "@mui/icons-material/PictureAsPdfRounded";

function DownloadPdfButton({ pdfPath, pdfFileName }) {
  return (
    <Tooltip title="Завантажити PDF">
      <IconButton
        component="a"
        href={pdfPath}
        download={pdfFileName}
        aria-label="Завантажити PDF"
        className="pdf-download-button"
      >
        <PictureAsPdfRoundedIcon />
      </IconButton>
    </Tooltip>
  );
}

export default DownloadPdfButton;
